import { APIClient } from "../helpers/api_helper";
import * as url from "../helpers/url_helper";

const api = new APIClient();

export const getSessionListService = (params = {}) => {
  return api.get(url.GET_ALL_SESSIONS, params);
};

export const addSessionService = (requestParams = {}) => {
  return api.create(url.ADD_SESSIONS, requestParams);
};

export const deleteSessionService = (id) => {
  return api.delete(url.DELETE_SESSION(id));
};

export const editSessionService = (queryParams) => {
  return api.create(url.EDIT_SESSION, queryParams);
};

export const updateSessionStatusService = (id, status, data = {}) => {
  return api.put(url.PUT_SESSION_STATUS(id), data, status, true);
};

// export const getCategoryByIdService=(id)=>{
//   return api.get(url.GET_MEAL_CATEGORY(id));
// }
